import Vue from 'vue';
import moment from 'moment';
import { QUESTION_TYPES } from './constants';

Vue.filter('itextbookTypeFilter', (itextbookType) => {
	let type;
	switch (itextbookType) {
		case 1:
			type = '1v1';
			break;
		case 4:
			type = '1v4';
			break;
		case 12:
			type = '1v12';
			break;
		default:
			'unknow';
	}
	return type;
});


Vue.filter('dateFormat', (date, format = 'YYYY-MM-DD HH:mm:ss') => {
	if (!date) {
		return '-';
	}
	date = moment(date);
	if (date.isValid()) {
		return date.format(format);
	} else {
		return 'Invalid Date';
	}
});

Vue.filter('json', (data) => {
	return JSON.stringify(data, null, 2);
});

Vue.filter('questionType', (type, lang) => {
	return QUESTION_TYPES[type] || type;
});

Vue.filter('checkStatus', (status) => {
	let text;
	switch (status) {
		case 'editing': text = '编辑中'; break;
		case 'waiting': text = '待审校'; break;
		case 'resolved': text = '审校通过'; break;
		case 'rejected': text = '审校未通过'; break;
		default: text = status;
	}
	return text;
});